import { render, staticRenderFns } from "./InvoicesList.vue?vue&type=template&id=af402ac2&scoped=true&"
import script from "./InvoicesList.vue?vue&type=script&lang=js&"
export * from "./InvoicesList.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesList.vue?vue&type=style&index=0&id=af402ac2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af402ac2",
  null
  
)

export default component.exports